import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { history } from '../history';
import { AuthConstant } from './constants/AuthConstant';
import { ProductConstant } from './constants/ProductConstant';
import { ProgramConstant } from './constants/ProgramConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';
// FEAT-025 — legacy user 응답에 dealerType 필드가 없을 때 'internal' 보정.
import { normalizeUserDealerType } from '../lib/userNormalize';
// IMP-426 PR #539 리뷰 Minor(Security) — 계정 전환 시 이전 계정의 mg/스코프 캐시 잔존 방지.
import { clearManagerGroupCache } from '../lib/managerGroupResolver';
import { clearScopeContextCache } from '../lib/scopeContext';
import { clearAllocationQueryDedupeCache } from '../lib/smartDentQueries';
// 사용자 실측 재현 — 명시적 로그아웃 뒤 AuthRoute 리다이렉트가 state.from 에 이전 사용자의
// 경로를 실어 다음 로그인의 resolvePostLoginPath 복귀 경로로 재사용되는 것을 차단하기 위해
// 기존 SSoT(resolveUnauthRedirect)로 로그인 화면을 판정한다.
import { resolveUnauthRedirect } from '../lib/loginRedirect';
// BUG-241 — 인증 판정/저장 경로를 safeStorage 로 통일 (차단 환경 SecurityError 방지).
import { safeGetJSON, safeSetItem, safeRemoveItem } from '../lib/safeStorage';
// IMP-475 P2c — 내 설정 언어 반영: 언어 파일·맞춤 번역·날짜 언어.
import { resolveUserLangCode } from '../config/currentLang';
import { loadLang } from '../config/langResources';
import { syncMomentLocaleFromStorage } from '../config/momentLocale';
import { TranslateAction } from './TranslateAction';


// BUG-241 F-002 — safeSetItem 은 실패 시 false 를 반환할 뿐 throw 하지 않고, console.warn 은
// safeStorage 래퍼가 이미 수행한다. 호출부가 반환값을 검사하지 않으면 쓰기만 막힌 환경(용량 초과 등)
// 에서 저장 실패가 그대로 로그인 성공으로 처리돼 Redux/스토리지 불일치(AuthRoute 무한 루프)가 된다.
// 로그인 3키(user/clist/userToken)를 한 번에 저장하고 성공 여부를 boolean 으로 반환하는 로컬 헬퍼.
const saveLoginStorage = (normalizedUser, jwt) => {
	const okUser = safeSetItem('user', JSON.stringify(normalizedUser));
	const okClist = safeSetItem('clist', normalizedUser?.clist);
	const okToken = safeSetItem('userToken', jwt);
	return okUser && okClist && okToken;
};

const Login = (username, password, isAdmin) => async (dispatch) => {
	dispatch({ type: AuthConstant.LOADING });
	dispatch({ type: AuthConstant.LOGIN_REQUEST, user: username });
	try {
		const data = {
			adminid: username,
			password: password,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/auth', { data: data });

		if (ret.data.status == 'success') {
			if (ret.data.data.user.adminid) {
				// FEAT-025 — dealerType legacy fallback. localStorage / Redux 모두 정규화 값 사용.
				const normalizedUser = normalizeUserDealerType(ret.data.data.user);
				if (saveLoginStorage(normalizedUser, ret.data.data.jwt)) {
					dispatch(!isAdmin ?
						{ type: AuthConstant.LOGIN_SUCCESS, user: normalizedUser, userToken: ret.data.data.jwt } :
						{ type: AuthConstant.ADMINLOGIN_SUCCESS, user: normalizedUser, userToken: ret.data.data.jwt });
				} else {
					dispatch({ type: AuthConstant.LOGIN_FAILURE, error: ret.data.err });
					dispatch(AlertAction.ErrorMsg("Login Failed"));
				}
			} else {
				dispatch({ type: AuthConstant.LOGIN_FAILURE, error: ret.data.err });
				dispatch(AlertAction.Error(ret.data));
			}
		} else {
			dispatch({ type: AuthConstant.LOGIN_FAILURE, error: ret.data.err });
			dispatch(AlertAction.ErrorMsg("Login Failed"));
		}
	} catch (error) {
		dispatch({ type: AuthConstant.LOGIN_FAILURE, error: error.message });
		dispatch(AlertAction.ErrorMsg("Login Failed"));
	}
	dispatch({ type: AuthConstant.LOADED });
};

const SendEmail = (_type, _email) => {
	return {};
};

const RequestForgotPassword = async (data) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/auth/requestForgotPassword', { data: data });
		return ret.data;
	} catch (error) {
		return { status: 'fail', errors: [], errmsg: 'Network error' };
	}
};

const UpdatePasswordByForgot = async (data) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/auth/resetPasswordByForgot', { data: data });
		return ret.data;
	} catch (error) {
		return { status: 'fail', errors: [], errmsg: 'Network error' };
	}
};

const UpdatePasswordByAdmin = async (adminid, passwordData) => {
	try {
		const user = getUserInfoByStorage();
		const reqData = {
			who: user.adminid,
			type: 'updatePasswordForAdmin',
			data: passwordData,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + adminid, reqData, JWT());
		return ret.data;
	} catch (error) {
		return { status: 'fail', errors: [], errmsg: 'Network error' };
	}
};

const UpdateUserFav = (type, favData) => async (dispatch) => {
	dispatch({ type: AuthConstant.LOADING });
	try {
		const user = getUserInfoByStorage();
		const data = {
			who: user.adminid,
			type: 'update',
			data: favData,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + user.adminid, data, JWT());
		if (ret.data.status == 'success') {
			if (safeSetItem('user', JSON.stringify(normalizeUserDealerType(ret.data.data)))) {
				dispatch({ type: ProductConstant.UPDATE_FAVS, favs: { type: type, data: favData } });
				dispatch(AlertAction.Success(t('common.message.success.saved')));
			} else {
				dispatch(AlertAction.ErrorMsg("Update Failed"));
			}
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: AuthConstant.LOADED });
};

const UpdateUserAdminFilters = (filters) => async (dispatch) => {
	try {
		const user = getUserInfoByStorage();
		const data = {
			who: user.adminid,
			type: 'update',
			data: filters,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + user.adminid, data, JWT());
		if (ret.data.status == 'success') {
			const normalizedUser = normalizeUserDealerType(ret.data.data);
			if (safeSetItem('user', JSON.stringify(normalizedUser))) {
				dispatch({ type: AuthConstant.UPDATE_ADMINFILTERS, user: normalizedUser });
			} else {
				dispatch(AlertAction.ErrorMsg("Failed to save filters."));
			}
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
};

// IMP-236/237: prototype pollution segment 화이트리스트 (gateway 가드 + segment 가드 공유).
const PROTOTYPE_POLLUTION_SEGMENTS = new Set(['__proto__', 'constructor', 'prototype']);

/**
 * IMP-236/237: 단일 update key segment 안전성 검사 — single source of truth.
 *
 * gateway 가드(`hasUnsafeUpdatePayload`) 와 신규 thunk 의 segment 입력 가드가 동일한 룰을
 * 공유하도록 본 헬퍼만 수정하면 양쪽 방어 수준이 자동 동기화된다.
 *
 * 차단 segment:
 *  - non-string / 빈 문자열
 *  - `$` prefix (MongoDB operator)
 *  - prototype pollution (`__proto__` / `constructor` / `prototype`)
 *  - dotted (자체 prefix 누적 차단)
 */
const isValidUpdateKeySegment = (segment) => {
	if (typeof segment !== 'string' || segment === '') return false;
	if (segment.startsWith('$')) return false;
	if (PROTOTYPE_POLLUTION_SEGMENTS.has(segment)) return false;
	if (segment.includes('.')) return false;
	return true;
};

/**
 * IMP-237: gateway 가드 — UpdateUser/UpdateUserAdminSetting generic export 의 dotted-key /
 * `$` prefix / 배열 / prototype pollution 입력 거부. BUG-117 silent drop 재발 경로
 * (`UpdateUser({'settings.x': v})`) 를 차단. 신규 thunk(updateUserSetting/updateUserAdminHeader)
 * 는 내부 `_core` 헬퍼를 직접 호출하여 가드 우회한다.
 *
 * **shallow check** — `Object.keys` top-level 만 검사. 중첩 값(`{ok: {'$set': evil}}`,
 * `{ok: {'__proto__': x}}`) 은 통과. BE sanitizeUpdateData(SEC-007/BUG-116) 의 deep
 * sanitize 와 짝지어 다중 방어. FE 측은 silent drop 재발 차단이 본질 목표.
 */
const hasUnsafeUpdatePayload = (userinfo) => {
	if (!userinfo || typeof userinfo !== 'object') return true;
	if (Array.isArray(userinfo)) return true;
	// isValidUpdateKeySegment 와 룰 공유 — 한쪽만 수정해도 양쪽 가드 동기화.
	return Object.keys(userinfo).some((k) => !isValidUpdateKeySegment(k));
};

/**
 * IMP-237: gateway 가드 위반 시 공통 거부 처리 — console.warn + ErrorMsg dispatch.
 * `UpdateUser` / `UpdateUserAdminSetting` 모두 동일 5줄 블록을 사용했으므로 helper 로 추출.
 */
const rejectUnsafeUpdate = (dispatch, label, errMsg) => {
	console.warn(`[IMP-237] ${label}: unsafe payload rejected (dotted-key / \`$\` prefix / array / prototype pollution).`);
	dispatch(AlertAction.ErrorMsg(errMsg));
};

// IMP-237: _updateUserAdminSettingCore — 기존 UpdateUserAdminSetting body (dashboard mirror
// 로직 + axios.post) 그대로. 외부에 export 안 함 → gateway 가드 우회 경로는 신규 thunk 만.
const _updateUserAdminSettingCore = (userinfo) => async (dispatch) => {
	const user = getUserInfoByStorage();

	if (userinfo.hasOwnProperty('dashboardSettingMainNewInstalledByCountry') ||
		userinfo.hasOwnProperty('dashboardSettingMainNewInstalledByModel') ||
		userinfo.hasOwnProperty('dashboardSettingMainNewInstalledTile')) {

		const settingValue = (userinfo.hasOwnProperty('dashboardSettingMainNewInstalledByCountry') && userinfo['dashboardSettingMainNewInstalledByCountry']) ||
			(userinfo.hasOwnProperty('dashboardSettingMainNewInstalledByModel') && userinfo['dashboardSettingMainNewInstalledByModel']) ||
			(userinfo.hasOwnProperty('dashboardSettingMainNewInstalledTile') && userinfo['dashboardSettingMainNewInstalledTile'])

		userinfo = {
			...userinfo,
			dashboardSettingMainNewInstalledByCountry: settingValue,
			dashboardSettingMainNewInstalledByModel: settingValue,
			dashboardSettingMainNewInstalledTile: settingValue,
		}
	}

	if (userinfo.hasOwnProperty('dashboardSettingProductNewInstalledTile') ||
		userinfo.hasOwnProperty('dashboardSettingProductNewInstalledByModel') ||
		userinfo.hasOwnProperty('dashboardSettingProductLastInstalled')) {

		const settingValue = (userinfo.hasOwnProperty('dashboardSettingProductNewInstalledTile') && userinfo['dashboardSettingProductNewInstalledTile']) ||
			(userinfo.hasOwnProperty('dashboardSettingProductNewInstalledByModel') && userinfo['dashboardSettingProductNewInstalledByModel']) ||
			(userinfo.hasOwnProperty('dashboardSettingProductLastInstalled') && userinfo['dashboardSettingProductLastInstalled'])

		userinfo = {
			...userinfo,
			dashboardSettingProductNewInstalledTile: settingValue,
			dashboardSettingProductNewInstalledByModel: settingValue,
			dashboardSettingProductLastInstalled: settingValue,
		}
	}

	if (userinfo.hasOwnProperty('dashboardSettingServiceClosedTicketTile') ||
		userinfo.hasOwnProperty('dashboardSettingServiceClosedTicket')) {

		const settingValue = (userinfo.hasOwnProperty('dashboardSettingServiceClosedTicketTile') && userinfo['dashboardSettingServiceClosedTicketTile']) ||
			(userinfo.hasOwnProperty('dashboardSettingServiceClosedTicket') && userinfo['dashboardSettingServiceClosedTicket'])

		userinfo = {
			...userinfo,
			dashboardSettingServiceClosedTicketTile: settingValue,
			dashboardSettingServiceClosedTicket: settingValue,
		}
	}

	if (userinfo.hasOwnProperty('dashboardSettingErrorClosedErrorTile') ||
		userinfo.hasOwnProperty('dashboardSettingErrorClosedError')) {

		const settingValue = (userinfo.hasOwnProperty('dashboardSettingErrorClosedErrorTile') && userinfo['dashboardSettingErrorClosedErrorTile']) ||
			(userinfo.hasOwnProperty('dashboardSettingErrorClosedError') && userinfo['dashboardSettingErrorClosedError'])

		userinfo = {
			...userinfo,
			dashboardSettingErrorClosedErrorTile: settingValue,
			dashboardSettingErrorClosedError: settingValue,
		}
	}

	const data = { who: user.adminid, type: 'update', data: userinfo, };

	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + user.adminid, data, JWT());
		if (ret.data.status == 'success') {
			const normalizedUser = normalizeUserDealerType(ret.data.data);
			if (safeSetItem('user', JSON.stringify(normalizedUser))) {
				dispatch({ type: AuthConstant.UPDATE_ADMINSETTING, user: normalizedUser });
			} else {
				dispatch(AlertAction.ErrorMsg("Failed to save settings."));
			}
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
};

// IMP-237 gateway: 외부 호출자가 dotted-key / `$` prefix / 배열 / prototype pollution
// 페이로드를 보내면 거부. 신규 호출자는 updateUserAdminHeader thunk 를 사용해야 함.
const UpdateUserAdminSetting = (userinfo) => async (dispatch) => {
	if (hasUnsafeUpdatePayload(userinfo)) {
		rejectUnsafeUpdate(dispatch, 'UpdateUserAdminSetting', 'Invalid admin setting payload');
		return;
	}
	return _updateUserAdminSettingCore(userinfo)(dispatch);
};

const UpdateUserRoleCompany = (userinfo) => async (dispatch) => {
	dispatch({ type: AuthConstant.LOADING });
	try {
		const user = getUserInfoByStorage();
		const data = {
			who: user.adminid,
			type: 'update',
			data: userinfo,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + user.adminid, data, JWT());
		if (ret.data.status == 'success') {
			const normalizedUser = normalizeUserDealerType(ret.data.data);
			if (safeSetItem('user', JSON.stringify(normalizedUser))) {
				dispatch({ type: AuthConstant.UPDATE_SUCCESS, user: normalizedUser });
				const loc = history.location.pathname;
				history.push('/Admin/AdminEmpty');
				setTimeout(() => {
					history.replace(loc);
				});
			} else {
				dispatch(AlertAction.ErrorMsg("Update Failed"));
			}
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: AuthConstant.LOADED });
};

const _updateUserCore = (userinfo) => async (dispatch) => {
	dispatch({ type: AuthConstant.LOADING });
	let saved = false;
	try {
		const user = getUserInfoByStorage();
		const data = {
			who: user.adminid,
			type: 'update',
			data: userinfo,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + user.adminid, data, JWT());
		if (ret.data.status == 'success') {
			const normalizedUser = normalizeUserDealerType(ret.data.data);
			if (safeSetItem('user', JSON.stringify(normalizedUser))) {
				dispatch({ type: AuthConstant.UPDATE_SUCCESS, user: normalizedUser });
				dispatch(AlertAction.Success(t('common.message.success.saved')));
				saved = true;
			} else {
				dispatch(AlertAction.ErrorMsg("Update Failed"));
			}
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: AuthConstant.LOADED });
	return saved;
};

// IMP-237 gateway: 외부 호출자가 dotted-key / `$` prefix / 배열 / prototype pollution
// 페이로드를 보내면 거부. 신규 호출자는 updateUserSetting thunk 를 사용해야 함.
const UpdateUser = (userinfo) => async (dispatch) => {
	if (hasUnsafeUpdatePayload(userinfo)) {
		rejectUnsafeUpdate(dispatch, 'UpdateUser', 'Invalid user update payload');
		return false;
	}
	return _updateUserCore(userinfo)(dispatch);
};

const checkPassword = async (password) => {
	try {
		const user = getUserInfoByStorage();
		const data = {
			who: user.adminid,
			type: 'checkPassword',
			data: {
				password: password,
			},
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + user.adminid, data, JWT());
		return ret.data.status == 'success';
	} catch (error) {
		return false;
	}
};

const isLogin = (_state) => {
	return isLogged();
};

const isAdmin = (state) => {
	return state.AuthReducer.isAdmin;
};

const ClearUpdateResult = () => (dispatch) => {
	dispatch({ type: AuthConstant.CLEAR_UPDATERES });
};

const getUserInfo = (state) => {
	return state.AuthReducer.user;
};

const Logout = () => (dispatch) => {
	safeRemoveItem('user');
	safeRemoveItem('clist');
	safeRemoveItem('userToken');

	safeRemoveItem('rtUser');
	safeRemoveItem('rtToken');

	try { sessionStorage.clear(); } catch (e) {} // 계정 간 세션 UI 상태(보고서 필터·loadedTab 등) 누수 방지
	clearManagerGroupCache(); // 계정 간 mg 매핑 잔존 방지 (IMP-426)
	clearScopeContextCache(); // 계정 간 스코프(managerGroupId/receivedRecord) 잔존 방지 (IMP-426)
	clearAllocationQueryDedupeCache(); // 계정 간 allocation 원장/딜러목록 잔존 방지 (BUG-211 R3 리뷰)

	dispatch({ type: ProgramConstant.SIDEMENU_CLOSE })
	dispatch({ type: AuthConstant.LOGOUT });

	// 사용자 실측 재현: 화면 이동 없이 저장소만 비우면, 마운트된 AuthRoute 가 "미로그인 사용자가
	// 보호 경로에 있다"고 판단해 리다이렉트하며 그 경로를 state.from 에 실어 보낸다. 다음 로그인이
	// 그 경로로 복귀해버려 A 가 로그아웃한 자리에 B 가 앉는 문제가 생긴다(경로 권한 검사로는 차단 불가).
	// replace + state 없음으로 로그인 화면에 직접 진입시켜 복귀 경로 자체가 생기지 않게 한다.
	const target = resolveUnauthRedirect(history.location.pathname);
	if (target) {
		history.replace(target);
	}
};

/* not export */
const getUserInfoByStorage = () => {
	return safeGetJSON('user');
};

const isAdminAccess = () => {
	const user = safeGetJSON('user');
	if (!user)
		return false;
	if (!user.permAdminAccess) {
		return false;
	}
	return true;
};
const isLogged = () => {
	const user = safeGetJSON('user');
	if (!user)
		return false;
	if (!user.adminid)
		return false;
	return true;
};

const UpdatePasswordModify = async (data) => {
	try {
		const user = getUserInfoByStorage();
		const reqData = {
			who: user.adminid,
			type: 'updatePassword',
			data: data,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/user/' + user.adminid, reqData, JWT());
		return ret.data.status == 'success';
	} catch (error) {
		return false;
	}
};

// IMP-236: user.update dotted payload action creator 추상화.
// 호출 사이트가 BE 계약(`settings.` / `adminheaders.` prefix) 을 직접 알지 않도록
// payload shape 책임을 action creator 레이어로 일원화. 향후 BE 계약 변경 시
// 호출 사이트 grep 없이 본 thunk 만 수정.
//
// BUG-117 회귀 가드: 평면 dotted payload 만 생성 (top-level `$set` operator wrapper
// 없음) — BE sanitizeUpdateData 의 `$` prefix 차단(SEC-007/BUG-116) 과 호환.
//
// 명명 컨벤션 (현재 상태: 진행 중 마이그레이션):
//   - 본 파일 기존 thunk 는 PascalCase 였으나 IMP-236 이후 신규 thunk 는 camelCase 표준화.
//   - 기존 PascalCase thunk 는 호환 유지 목적으로 현 PR 에서는 변경하지 않는다.
//   - 전체 일괄 마이그레이션은 별도 IMP 등록 필요 (PR scope 단일 IMP 원칙).

// BE `SCHEMALESS_TOPLEVEL_FIELDS` 와 silent drift 방지 — top-level dotted prefix 상수화.
const USER_SETTING_PREFIX = 'settings';
const USER_ADMIN_HEADER_PREFIX = 'adminheaders';

// IMP-237: 신규 thunk 는 _updateUserCore / _updateUserAdminSettingCore 헬퍼를 직접 호출하여
// gateway 가드(UpdateUser/UpdateUserAdminSetting 의 dotted-key 거부)를 우회한다. 이렇게
// 분리하지 않으면 신규 thunk 가 만든 평면 dotted payload 가 자신의 gateway 가드에 걸려
// 자기 자신을 차단하는 모순이 발생.
const updateUserSetting = (name, value) => async (dispatch) => {
	if (!isValidUpdateKeySegment(name)) {
		// fail-noisy: 가드 위반 시 콘솔 경고 + ErrorMsg dispatch (silent drop 회피).
		console.warn(`[IMP-236] updateUserSetting: invalid name segment "${name}" — request rejected.`);
		dispatch(AlertAction.ErrorMsg('Invalid setting key'));
		return false;
	}
	return _updateUserCore({ [`${USER_SETTING_PREFIX}.${name}`]: value })(dispatch);
};

const updateUserAdminHeader = (prefix, filter) => async (dispatch) => {
	if (!isValidUpdateKeySegment(prefix)) {
		console.warn(`[IMP-236] updateUserAdminHeader: invalid prefix segment "${prefix}" — request rejected.`);
		dispatch(AlertAction.ErrorMsg('Invalid header prefix'));
		return;
	}
	if (!Array.isArray(filter)) {
		console.warn('[IMP-236] updateUserAdminHeader: filter must be an array — request rejected.');
		dispatch(AlertAction.ErrorMsg('Invalid header filter'));
		return;
	}
	return _updateUserAdminSettingCore({ [`${USER_ADMIN_HEADER_PREFIX}.${prefix}`]: filter })(dispatch);
};

// IMP-475 P2c — 저장본(localStorage user)은 로그인 때의 사본이라 관리자가 바꾼 내 설정을 못 본다.
// 서버 사용자에서 rguardSetting* 만 저장본에 덮어쓴다(다른 필드·모양은 유지). 실패는 throw 하지 않고 null.
// action type 은 리듀서가 { ...state, user } 만 하는 UPDATE_ADMINSETTING 을 재사용(새 상수·리듀서 변경 없이 AuthReducer.user 만 교체).
const ApplyMySettingsFromServer = (serverUser) => async (dispatch) => {
	const warn = (msg) => console.warn('[AuthAction.ApplyMySettingsFromServer]', String(msg ?? '').slice(0, 200));
	try {
		const stored = getUserInfoByStorage();
		if (!stored?.adminid) {
			warn('no stored user/adminid — apply skipped');
			return null;
		}
		if (!serverUser || typeof serverUser !== 'object') {
			warn('server user is not an object — apply skipped');
			return null;
		}
		if (serverUser.adminid && serverUser.adminid !== stored.adminid) {
			warn('adminid mismatch — apply skipped');
			return null;
		}
		const patch = {};
		Object.keys(serverUser).forEach((k) => {
			if (k.startsWith('rguardSetting') && JSON.stringify(serverUser[k]) !== JSON.stringify(stored[k])) {
				patch[k] = serverUser[k];
			}
		});
		if (Object.keys(patch).length === 0) return stored;
		const merged = { ...stored, ...patch };
		const prevLang = resolveUserLangCode(stored);
		const nextLang = resolveUserLangCode(merged);
		const langChanged = prevLang !== nextLang;
		if (langChanged) {
			// 저장본이 바뀌면 Translate 가 즉시 새 코드로 해석하므로 loadLang 완료 뒤에 저장한다(langResources.js IMP-328 규칙).
			// 맞춤 번역 실패는 언어 전환을 막지 않는다.
			const customTranslate = Promise.resolve()
				.then(() => TranslateAction.SearchByLanguageDirect(nextLang))
				.then((r) => {
					if (Array.isArray(r)) {
						safeSetItem('translate', JSON.stringify(r));
					} else {
						warn('custom translate response is not an array — skipped');
					}
				})
				.catch((e) => warn(`custom translate failed: ${e?.message || e}`));
			await Promise.all([loadLang(nextLang), customTranslate]);
		}
		if (!safeSetItem('user', JSON.stringify(merged))) {
			warn('localStorage write failed');
			return null;
		}
		if (langChanged) syncMomentLocaleFromStorage();
		dispatch({ type: AuthConstant.UPDATE_ADMINSETTING, user: merged });
		return merged;
	} catch (error) {
		warn(error?.message || 'apply failed');
		return null;
	}
};

const RefreshMySettings = () => async (dispatch) => {
	const warn = (msg) => console.warn('[AuthAction.RefreshMySettings]', String(msg ?? '').slice(0, 200));
	try {
		const stored = getUserInfoByStorage();
		if (!stored?.adminid) {
			warn('no stored user/adminid — request skipped');
			return null;
		}
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/user/' + stored.adminid, JWT());
		const server = ret?.data?.data;
		if (ret?.data?.status !== 'success' || !server || typeof server !== 'object') {
			warn(ret?.data?.errmsg || ret?.data?.err || 'unexpected response');
			return null;
		}
		return await dispatch(ApplyMySettingsFromServer(server));
	} catch (error) {
		warn(error?.message || 'request failed');
		return null;
	}
};

export const AuthAction = {
	Login,
	ApplyMySettingsFromServer,
	RefreshMySettings,
	Logout,
	SendEmail,
	isLogged,
	isLogin,
	isAdmin,
	isAdminAccess,
	checkPassword,
	UpdateUser,
	UpdateUserRoleCompany,
	UpdateUserFav,
	ClearUpdateResult,
	getUserInfo,
	UpdatePasswordModify,
	RequestForgotPassword,
	UpdatePasswordByForgot,
	UpdateUserAdminSetting,
	UpdateUserAdminFilters,
	UpdatePasswordByAdmin,
	updateUserSetting,
	updateUserAdminHeader,
};
